import React, { useState } from 'react'
import styles from './index.module.scss'
import { useHistory } from 'react-router-dom'
import { TextareaItem } from 'antd-mobile'
import 'antd-mobile/dist/antd-mobile.css'
import { setEvent } from '@/core/utile'
import SelectComplaintType, {
  COMPLAINT_TYPES,
  ComplaintType,
} from '../select-type'
import { ORIGIN_URL_KEY } from '@/pages/complaint/helper'
export const SelectComplaintSubmit = ({
  title,
  lists = COMPLAINT_TYPES,
}: {
  title?: string
  lists?: ComplaintType[]
}) => {
  if (!lists) {
    return <></>
  }
  console.log('item.selectListInfo.list :>> ', lists)
  return <SelectComplaintType title={title} lists={lists} />
}
export default function ComplaintSubmit() {
  const [inputValue, setInputValue] = useState<string | undefined>('')
  const history = useHistory()
  const handleSubmit = () => {
    setEvent('ra_complaint_submit', {
      content: inputValue,
      origin_url: sessionStorage.getItem(ORIGIN_URL_KEY),
    })
    setTimeout(() => {
      history.push('/complaint_submit_result')
    }, 200)
  }
  return (
    <div className={styles.container}>
      <div className={styles.title}>提交证据材料</div>

      <div className={styles.info_form}>
        <div className={styles.info_form_item}>
          <div className={styles.info_form_item_label}>
            <div>投诉说明</div>
            <div>（选填）</div>
          </div>
          <div className={styles.info_form_item_value}>
            <TextareaItem
              value={inputValue}
              className={styles.input}
              autoHeight
              placeholder={'填写投诉说明'}
              onChange={value => {
                setInputValue(value)
              }}
            />
          </div>
        </div>
      </div>

      <div className={styles.main_button} onClick={handleSubmit}>
        提交
      </div>
    </div>
  )
}
